// extracted by mini-css-extract-plugin
export default {"placement-test-wrapper":"PlacementTest_placement-test-wrapper__vZqzq","loadingWrapper":"PlacementTest_loadingWrapper__L3rIv"};